import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {Link, Paper} from '@material-ui/core';
import {useParams} from "react-router";
import PublicAvatarView from "./PublicAvatarView";
import {BASE_URL} from "../../../../baseUrls";
import InfoText from "../../../util/common/InfoText";

const styles = {
  root:{
    maxWidth:'800px',
    width:'calc(100% - 2rem)',
    margin:'1rem auto',
    overflow:'auto',
    border: '1px solid rgba(0,0,0,0.17)',
  },
  info:{
    maxWidth:'800px',
    width:'calc(100% - 2rem)',
    margin:'1rem auto',
    // fontWeight: 300,
  },
  link:{
    textTransform: 'uppercase',
    fontSize: '0.85em',
    fontWeight: 500,
  },
  linkSecondary:{
    fontWeight: 300,
  }
};

function PublicAvatarPage(props) {
  const { classes } = props;
  let {botName} = useParams();

  return (
    <div>
      <Paper className={classes.root}>
        <InfoText className={classes.info}>
          <Link href={BASE_URL} underline="always" color="primary" className={classes.link}>LifeNaut</Link> is a web based research project that allows anyone
          to <Link className={classes.linkSecondary} href={`${BASE_URL}/learn-more/`}>create a free back-up of their mind</Link> and <Link className={classes.linkSecondary} href={`${BASE_URL}/biofile`}>genetic code</Link>.
        </InfoText>
      </Paper>
      <Paper className={classes.root}>
        <PublicAvatarView botName={botName} />
      </Paper>
    </div>
  );
}

export default withStyles(styles)(PublicAvatarPage);
